import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

/** Wraps a route to require an authenticated user. Redirects unauth'd users
 *  to /login while preserving the original target in `state.from`.
 *
 *  Optional `requireRole`: if specified, only users with that role can access.
 */
export default function ProtectedRoute({ children, requireRole = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500" data-testid="auth-loading">
        טוען...
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/S.ADMIN" replace />;
  }
  return children;
}
